import { render, staticRenderFns } from "./MyInvite.vue?vue&type=template&id=56d1a72a&"
import script from "./MyInvite.vue?vue&type=script&lang=js&"
export * from "./MyInvite.vue?vue&type=script&lang=js&"
import style0 from "./MyInvite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports